import { ReactNode } from 'react';
import { Button, Icon, Typography } from '@equinor/eds-core-react';
import { edit } from '@equinor/eds-icons';
import styled from 'styled-components';

Icon.add({ edit });

const HeaderRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 1rem;
  flex-wrap: wrap;
`;

const RightMeta = styled.div`
  margin-left: auto;
`;

type EditableFieldHeaderProps = {
  title: string;
  onEdit: () => void;
  rightMeta?: ReactNode;
};

export const EditableFieldHeader = ({
  title,
  onEdit,
  rightMeta,
}: EditableFieldHeaderProps) => {
  return (
    <HeaderRow>
      <Typography variant="h3">{title}</Typography>
      <Button variant="ghost_icon" onClick={onEdit}>
        <Icon name="edit" />
      </Button>
      {rightMeta ? <RightMeta>{rightMeta}</RightMeta> : null}
    </HeaderRow>
  );
};
